document.addEventListener("DOMContentLoaded", function () {
	const animatedElements = document.querySelectorAll('.scroll-animated');

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('animate__animated', 'animate__fadeInUp', 'animate__slow'); // Change the animation class as needed
				observer.unobserve(entry.target); // Stop observing after animation has been applied
			}
		});
	});

	animatedElements.forEach((element) => {
		observer.observe(element);
	});

});



